import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Drawer from "@mui/material/Drawer";
import InfoIcon from '@mui/icons-material/Info';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import {styled} from '@mui/material/styles';
import {Typography} from "@mui/material";
import SchoolIcon from '@mui/icons-material/School';
import {Link} from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import {sideBarInfo} from "../data/mock-date";
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import '../components-css/side-bar.scss'

const DrawerHeader = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(0, 1),
    // necessary for content to be below app bar
    ...theme.mixins.toolbar,
    justifyContent: 'space-around',
}));

const SideBar = () => {
    const [open, setOpen] = React.useState(false);

    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };

    const scrollToTop = () => () => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }

    const DrawerList = (
        <Box sx={{width: 250}} role="presentation" onClick={toggleDrawer(false)}>
            <List>
                {sideBarInfo.map((model, index) => (
                    <Link to={model.link} key={index}>
                        <ListItem disablePadding>
                            <ListItemButton>
                                <ListItemIcon className={'for-width'}>
                                    {index === 0 ? <HomeIcon/> : index === 1 ? <InfoIcon/> : index === 2 ?
                                        <TrendingUpIcon/>
                                        : index === 3 ? <AssignmentIndIcon/> : <QuestionAnswerIcon/>}
                                </ListItemIcon>
                                <ListItemText primary={model.name}/>
                            </ListItemButton>
                        </ListItem>
                    </Link>
                ))}
            </List>
        </Box>
    );

    return (
        <AppBar position="fixed" color="warning" sx={{top: 0, bottom: 'auto', backgroundColor: "#b31684"}}>
            <Toolbar>
                <div className={'header-content'}>
                    <MenuIcon onClick={toggleDrawer(true)}/>
                    <Link to={"/"} onClick={scrollToTop()}>
                        <div className={'icon-wrapper'}>
                            <Typography variant="h7">WB Online Courses</Typography>
                            <SchoolIcon sx={{color: "#ffffff"}}/>
                        </div>
                    </Link>
                </div>
                <Drawer open={open} onClose={toggleDrawer(false)}>
                    <DrawerHeader>
                        <SchoolIcon sx={{color: "#b31684"}}/>
                        <Typography variant="h7">WB Online Courses</Typography>
                        <IconButton onClick={toggleDrawer(false)}>
                            <ChevronLeftIcon fontSize={"medium"}/>
                        </IconButton>
                    </DrawerHeader>
                    {DrawerList}
                </Drawer>
            </Toolbar>
        </AppBar>
    );
}

export default SideBar;
